import { render, staticRenderFns } from "./QuoteLetter.vue?vue&type=template&id=04ae7db1&scoped=true&"
import script from "./QuoteLetter.vue?vue&type=script&lang=js&"
export * from "./QuoteLetter.vue?vue&type=script&lang=js&"
import style0 from "./QuoteLetter.vue?vue&type=style&index=0&id=04ae7db1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04ae7db1",
  null
  
)

export default component.exports